export const createGlobalInstance = <T>(key: string, instantiator: () => T): T => {
    if (!window.globalInstances) {
        window.globalInstances = {}
    }

    if (!window.globalInstances[key]) {
        window.globalInstances[key] = instantiator()
    }

    return window.globalInstances[key]
}
